 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "_assets/js/" + ({"About":"About","ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8":"ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8","ActiveQuestions":"ActiveQuestions","AppLayout":"AppLayout","Campaign":"Campaign","CampaignRecords":"CampaignRecords","CheckIn~Home~Profile~ProfileEdit~Scanner~StampCard":"CheckIn~Home~Profile~ProfileEdit~Scanner~StampCard","CheckIn~Home~Profile~Scanner~StampCard":"CheckIn~Home~Profile~Scanner~StampCard","CheckIn":"CheckIn","Home":"Home","QA~QADetail~Scanner":"QA~QADetail~Scanner","Scanner":"Scanner","StampCard":"StampCard","ProfileEdit":"ProfileEdit","DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon":"DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon","AppointStoreMap~DigitalCard~ParkingCoupon~Send":"AppointStoreMap~DigitalCard~ParkingCoupon~Send","DigitalCard":"DigitalCard","ParkingCoupon":"ParkingCoupon","Error":"Error","Notification":"Notification","NotificationBar":"NotificationBar","QA~QADetail":"QA~QADetail","QA":"QA","QADetail":"QADetail","ScanError":"ScanError","Service":"Service","Survey":"Survey","Turntable":"Turntable","AppointStore":"AppointStore","AppointStoreMap":"AppointStoreMap","Send":"Send","Article":"Article","Articles":"Articles","Merchant~Profile":"Merchant~Profile","Profile":"Profile","Consumption":"Consumption","CustomerService":"CustomerService","DDwalletAgreement":"DDwalletAgreement","LimitedTimeMissionDetail":"LimitedTimeMissionDetail","Merchant":"Merchant","Download":"Download","Footer":"Footer","HealthyStep":"HealthyStep","MyStampCards":"MyStampCards","PaymentRecord":"PaymentRecord","Record":"Record","Setting":"Setting","SettingDeleteAccount":"SettingDeleteAccount","StoreInfo":"StoreInfo","StoreStamps":"StoreStamps","Stores":"Stores","Video":"Video","Websites":"Websites"}[chunkId]||chunkId) + "." + {"About":"38acd864","ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8":"1d490901","ActiveQuestions":"4df33e78","AppLayout":"61880d1d","Campaign":"ebeca5e2","CampaignRecords":"739a8fa7","CheckIn~Home~Profile~ProfileEdit~Scanner~StampCard":"8711a2ff","CheckIn~Home~Profile~Scanner~StampCard":"af8e4863","CheckIn":"b00a520c","Home":"bce3d335","QA~QADetail~Scanner":"c911eb8c","Scanner":"36b025f2","StampCard":"5fe204d5","ProfileEdit":"f74d673c","DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon":"b55ecd3c","AppointStoreMap~DigitalCard~ParkingCoupon~Send":"21335813","DigitalCard":"1ff481af","ParkingCoupon":"a4425ec7","Error":"0352a396","Notification":"57fec941","NotificationBar":"1ad1b65a","QA~QADetail":"95069839","QA":"50e4fd8b","QADetail":"e23fade5","ScanError":"7badd604","Service":"0ef01069","Survey":"12417a5d","Turntable":"f5b24268","AppointStore":"aab92ea0","AppointStoreMap":"5e4e8e11","Send":"1f1cc9fb","Article":"96bf71a9","Articles":"33fca659","Merchant~Profile":"9a9b35f2","Profile":"fd15f729","Consumption":"cccbafcc","CustomerService":"737a0a86","DDwalletAgreement":"5f31eef8","LimitedTimeMissionDetail":"94872534","Merchant":"ae275dd6","Download":"53982a0c","Footer":"1cf863c2","HealthyStep":"13e31374","MyStampCards":"b80acb47","PaymentRecord":"e7b69419","Record":"b2a33581","Setting":"eb45ae85","SettingDeleteAccount":"ec64bab7","StoreInfo":"c5fd4e7c","StoreStamps":"ba2d6225","Stores":"e7bef294","Video":"7fa0d937","Websites":"c551d073","chunk-3ed9be33":"6a13ccb0","chunk-6bab0a12":"56b79422"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8":1,"ActiveQuestions":1,"Campaign":1,"CheckIn~Home~Profile~Scanner~StampCard":1,"Home":1,"QA~QADetail~Scanner":1,"Scanner":1,"ProfileEdit":1,"DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon":1,"DigitalCard":1,"ParkingCoupon":1,"Notification":1,"QA~QADetail":1,"QA":1,"QADetail":1,"Service":1,"Turntable":1,"AppointStore":1,"AppointStoreMap":1,"Send":1,"Profile":1,"Consumption":1,"CustomerService":1,"DDwalletAgreement":1,"LimitedTimeMissionDetail":1,"Merchant":1,"Download":1,"HealthyStep":1,"Setting":1,"SettingDeleteAccount":1,"StoreInfo":1,"chunk-3ed9be33":1,"chunk-6bab0a12":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "_assets/css/" + ({"About":"About","ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8":"ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8","ActiveQuestions":"ActiveQuestions","AppLayout":"AppLayout","Campaign":"Campaign","CampaignRecords":"CampaignRecords","CheckIn~Home~Profile~ProfileEdit~Scanner~StampCard":"CheckIn~Home~Profile~ProfileEdit~Scanner~StampCard","CheckIn~Home~Profile~Scanner~StampCard":"CheckIn~Home~Profile~Scanner~StampCard","CheckIn":"CheckIn","Home":"Home","QA~QADetail~Scanner":"QA~QADetail~Scanner","Scanner":"Scanner","StampCard":"StampCard","ProfileEdit":"ProfileEdit","DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon":"DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon","AppointStoreMap~DigitalCard~ParkingCoupon~Send":"AppointStoreMap~DigitalCard~ParkingCoupon~Send","DigitalCard":"DigitalCard","ParkingCoupon":"ParkingCoupon","Error":"Error","Notification":"Notification","NotificationBar":"NotificationBar","QA~QADetail":"QA~QADetail","QA":"QA","QADetail":"QADetail","ScanError":"ScanError","Service":"Service","Survey":"Survey","Turntable":"Turntable","AppointStore":"AppointStore","AppointStoreMap":"AppointStoreMap","Send":"Send","Article":"Article","Articles":"Articles","Merchant~Profile":"Merchant~Profile","Profile":"Profile","Consumption":"Consumption","CustomerService":"CustomerService","DDwalletAgreement":"DDwalletAgreement","LimitedTimeMissionDetail":"LimitedTimeMissionDetail","Merchant":"Merchant","Download":"Download","Footer":"Footer","HealthyStep":"HealthyStep","MyStampCards":"MyStampCards","PaymentRecord":"PaymentRecord","Record":"Record","Setting":"Setting","SettingDeleteAccount":"SettingDeleteAccount","StoreInfo":"StoreInfo","StoreStamps":"StoreStamps","Stores":"Stores","Video":"Video","Websites":"Websites"}[chunkId]||chunkId) + "." + {"About":"31d6cfe0","ActiveQuestions~AppLayout~Campaign~CampaignRecords~CheckIn~DigitalCard~Error~Home~Notification~Notif~e0bf17e8":"9896c0fa","ActiveQuestions":"07018f02","AppLayout":"31d6cfe0","Campaign":"685a73c3","CampaignRecords":"31d6cfe0","CheckIn~Home~Profile~ProfileEdit~Scanner~StampCard":"31d6cfe0","CheckIn~Home~Profile~Scanner~StampCard":"45095726","CheckIn":"31d6cfe0","Home":"c58c2d2d","QA~QADetail~Scanner":"6881d026","Scanner":"79b993d2","StampCard":"31d6cfe0","ProfileEdit":"b12d205c","DigitalCard~LimitedTimeMissionDetail~Merchant~ParkingCoupon":"ef7817bc","AppointStoreMap~DigitalCard~ParkingCoupon~Send":"31d6cfe0","DigitalCard":"e053213f","ParkingCoupon":"edc6b3f7","Error":"31d6cfe0","Notification":"e97cea73","NotificationBar":"31d6cfe0","QA~QADetail":"176076b1","QA":"8c7f684e","QADetail":"f7f173ba","ScanError":"31d6cfe0","Service":"99851c54","Survey":"31d6cfe0","Turntable":"08d4355b","AppointStore":"575cea8c","AppointStoreMap":"9e5ec5f6","Send":"d32b8081","Article":"31d6cfe0","Articles":"31d6cfe0","Merchant~Profile":"31d6cfe0","Profile":"4f237e92","Consumption":"7be8b331","CustomerService":"d8ea277f","DDwalletAgreement":"3ddda78e","LimitedTimeMissionDetail":"921dffe7","Merchant":"da4d8580","Download":"4c500028","Footer":"31d6cfe0","HealthyStep":"88ddbd68","MyStampCards":"31d6cfe0","PaymentRecord":"31d6cfe0","Record":"31d6cfe0","Setting":"799928d3","SettingDeleteAccount":"5e211bad","StoreInfo":"dd3a67b8","StoreStamps":"31d6cfe0","Stores":"31d6cfe0","Video":"31d6cfe0","Websites":"31d6cfe0","chunk-3ed9be33":"e48d0d05","chunk-6bab0a12":"ddb9621e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
